import React from "react";
import { cn } from "../../styles";
import { Typography, TypographyContent } from "../../atoms";
import { Chip } from "../Chip";
import { LocalizationScope } from "../../util/LocalizationScope";

export interface CommonValueOption {
  label?: React.ReactNode;
  localKey?: string;
  value?: any;
  [key: string]: any;
}

export interface CommonValuesProps {
  options: CommonValueOption[];
  onSelect: (option: CommonValueOption) => void;
  localKey?: string;
  loading?: boolean;
  count?: number;
  disabled?: boolean;
  className?: string;
}

export const CommonValues = ({
  options,
  onSelect,
  localKey,
  loading,
  count = 3,
  disabled,
  className,
}: CommonValuesProps) => {
  return (
    <LocalizationScope scope={localKey}>
      <div className={cn("mt-1 flex flex-wrap gap-1", className)}>
        {loading &&
          [...Array(count)].map((_, idx) => (
            <div
              key={idx}
              className="h-6 w-[130px] rounded-full bg-back-200 dark:bg-back-700 animate-pulse"
            />
          ))}
        {!loading &&
          options.map((option, idx) => (
            <button
              key={idx}
              type="button"
              disabled={disabled}
              onClick={() => onSelect(option)}
              className="appearance-none border-0 bg-transparent p-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Chip dense>
                {option.label || (
                  <Typography.Span
                    content={
                      option.localKey
                        ? { local: option.localKey }
                        : ({ local: "CommonValue" } as TypographyContent)
                    }
                  />
                )}
              </Chip>
            </button>
          ))}
      </div>
    </LocalizationScope>
  );
};

CommonValues.displayName = "CommonValues";
